import { APIFileInstance } from '@/utils/functions/instance'

import { IUploadImageParamsType, IUploadImageResponseType } from './type'

export const uploadDocument = async (
  file: IUploadImageParamsType['file'],
  document_type: IUploadImageParamsType['document_type']
): Promise<IUploadImageResponseType> => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('file_extension', file.type.split('/').at(1) ?? '')
  formData.append('document_type', document_type)

  const response = await APIFileInstance.post<IUploadImageResponseType>(
    'mrf/documents/',
    formData
  )

  return response.data
}
